import { ChatMessageModel, WAChat } from "./chat";
import { WAConversationList } from "./list";
import { useEffect, useRef, useState } from "react";

import { ServerWebSocket } from "../../utils/ws";
import { URLS } from "../../env/urls";
import { getWsUrl } from "../../utils/wsurl";
import { CircularLoading } from "../utils/loading";
import { shortDescObjectByKey } from "../../utils/short";
import { ChatInfo } from "./types";
import {  formatDateWithMin } from "../../utils/date";
import { LoadingButton } from "@mui/lab";
import '../../css/emptychatcontainer.css'
import { userGetInfo } from "../../user/info";
import { openGlobalSnack } from "../utils/snack";
import { phoneEquals } from "../../utils/phone";
import { ChatCounts, ChatFacets, ChatFilterBar, ChatFilters, DEFAULT_CHAT_LIMIT } from "./filters";
import { getServerStates, ServerStates } from "../../utils/fgtschat/serverstates";

interface FGTSChatNormalizedInfo{
  id:number,
  currentState:string,
  script?:string,
  senderNumber:string,
  clientPhone:string,
  clientWhatsappId?:string,
  instagramId?:string,
  instagramUsername?:string,
  telegramId?:string,
  telegramUsername?:string,
  chatSource?:string,
  recipient?:string,
  client:{
      name?:string,
      phone?:string,
      whatsappId?:string,
      instagramId?:string,
      instagramUsername?:string,
      telegramId?:string,
      telegramUsername?:string,
      id?:number,
  },
  createdAt:string,
  updatedAt:string,
  isStoped:boolean,
  stopReason:string|false,
  isPremium:boolean,

}
interface NormalizedMessages{
  sender:string,
  receiver:string,
  text?:string,
  type:string,
  createdAt:string,
  rootNumber:string,
  id:number,
  media_path?:string,
  mime_type?:string,
}

// Payload que o WebSocket manda de volta em cada evento.
interface WSChatData{
  response:string,
  chat?:FGTSChatNormalizedInfo,
  msg?:NormalizedMessages,
  chats?:Array<FGTSChatNormalizedInfo>,
  msgs?:Array<NormalizedMessages>,
  total?:number,
  windowTotal?:number,
  shown?:number,
  limit?:number,
  channels?:ChatFacets['channels'],
  accounts?:ChatFacets['accounts'],
}

const DEFAULT_FILTERS:ChatFilters={channel:'',account:'',state:'',script:'',limit:DEFAULT_CHAT_LIMIT};



export function WAConteiner(){
     const [canSeeConversation,setCanSeeConversation]=useState<null|boolean>(null);
     useEffect(()=>{
        userGetInfo().then(e=>{
               if(!e){
                openGlobalSnack('Atualize a página','error');
                return;
               }
               setCanSeeConversation(e.permission.can_see_conversation);
        }).catch(e=>{
             openGlobalSnack('Atualize a página','error');
        })
        return ()=>{}
     },[])
     useEffect(()=>{
          document.title=`Conversas - IATechTeam`;
     },[])
     return (
         <>
            {!canSeeConversation?
              <div>
                {typeof(canSeeConversation)==='boolean'?<p>Acesso Negado.</p>:<CircularLoading/>}
              </div>
            :<WAChatConteiner/>}
         </>
     )
}



function WAChatConteiner(){
    const [selectedChat,setSelectedChat]=useState<ChatInfo|undefined>(undefined);
    const [isMobile,setIsMobile]=useState(window.innerWidth<1000);
    const [itemsHeight,setItemsHeight]=useState(window.innerHeight-240);
    const [ws,setWS]=useState<undefined|ServerWebSocket>(undefined);
    const [chats,setChats]=useState<undefined|Array<ChatInfo>>(undefined);
    const [messages,setMessages]=useState<Array<ChatMessageModel>>([]);
    const [lastPing,setLastPing]=useState(new Date());
    const [updateConection,setUpdateConection]=useState(false);
    const [mustUpdate,setMustUpdate]=useState(false);
    const [loadingChats,setLoadingChats]=useState(false);
    // Filtros de busca (canal, conta, estado, script, limite) + facets/contagens.
    const [filters,setFilters]=useState<ChatFilters>(DEFAULT_FILTERS);
    const [facets,setFacets]=useState<ChatFacets>({channels:[],accounts:[]});
    const [counts,setCounts]=useState<ChatCounts>({total:0,windowTotal:0,shown:0,limit:DEFAULT_CHAT_LIMIT});
    const [serverStates,setServerStates]=useState<ServerStates|undefined>(undefined);
    const ref=useRef<{filters:ChatFilters,getingChats?:boolean,selectedChat?:ChatInfo,messages:Array<ChatMessageModel>,chats?:Array<ChatInfo>,upJustChat?:boolean,triesReconection:number,updateChatMessages?:boolean}>({filters:DEFAULT_FILTERS,messages:[],triesReconection:0});
    // Mantém a instância viva do socket para fechar corretamente no unmount
    // (o estado `ws` no closure do cleanup pode estar defasado).
    const wsInstanceRef=useRef<ServerWebSocket|undefined>(undefined);
    useEffect(()=>{
       getServerStates().then(setServerStates).catch(()=>{});
    },[]);
    useEffect(()=>{
      if(!ws)
           return;
      ws.setOnmessage((data:{data:WSChatData})=>{
         setLastPing(new Date());

         switch(data.data.response){
              case 'Authenticated':
                  ws.send({action:'addListener'});
                  break;
              case 'getChats':
                 convertChatInfo(true,data.data.chats);
                 setCounts({
                    total:data.data.total||0,
                    windowTotal:data.data.windowTotal||0,
                    shown:typeof data.data.shown==='number'?data.data.shown:(data.data.chats?.length||0),
                    limit:data.data.limit||ref.current.filters.limit,
                 });
                 ref.current.triesReconection=0;
                 break;
              case 'getFilters':
                 setFacets({channels:data.data.channels||[],accounts:data.data.accounts||[]});
                 break;
              case 'getMessages':
                 updateMessages(true,data.data.msgs);
                 break;
              case 'listenerAdded':
                 setLoadingChats(true);
                 // Pede as facets (canais + contas) uma vez por conexão.
                 ws.send({action:'getFilters'});
                 break;
              case 'updatedMessage':
                if(!data.data.msg||!ref.current.selectedChat)
                   break;
               // Casa a mensagem ao chat pelo recipient (telefone OU wa_id),
               // tolerando o 9º dígito. Antes usava === em clientPhone, então
               // chats sem número (só wa_id) ou com/sem o 9 não recebiam nada.
               const chatRecipient=ref.current.selectedChat.recipient||ref.current.selectedChat.clientPhone;
               const account=ref.current.filters.account;
               if((phoneEquals(data.data.msg.sender,chatRecipient)||phoneEquals(data.data.msg.receiver,chatRecipient))&&
                   (!account||account==='all'||data.data.msg.sender===account||data.data.msg.receiver===account)){
                    updateMessages(false,[data.data.msg]);
                   }

                break;
              case 'updatedChat':
                if(!data.data.chat)
                   break;
                // Só integra o chat atualizado se ele casa com os filtros ativos.
                if(!chatMatchesFilters(data.data.chat))
                   break;
                if(ref.current.getingChats)
                    break;
                convertChatInfo(false,[data.data.chat]);
                break;
          }
      });
      ws.setOnclose((e:any)=>{setMustUpdate(true)});
      ws.setOnerror((e:any)=>{setMustUpdate(true)});
    },[ws]);
    useEffect(()=>{
      updateWS();
      return ()=>{
           // close() é definitivo: para o auto-reconnect do wrapper e encerra.
           wsInstanceRef.current?.close();
           wsInstanceRef.current=undefined;
      }
    },[]);
    // Mudou algum filtro: guarda no ref e, se o socket já está aberto, refaz a busca.
    useEffect(()=>{
      ref.current.filters=filters;
      if(ws&&ws.ws.readyState==WebSocket.OPEN)
          setLoadingChats(true);
    },[filters])
    useEffect(()=>{
        ref.current.selectedChat=selectedChat;
        if(selectedChat&&ws&&!ref.current.upJustChat){
            ref.current.updateChatMessages=true;
            setMessages([]);
        }
        ref.current.upJustChat=false;

    },[selectedChat]);
    useEffect(()=>{
         if(messages.length==0&&ref.current.updateChatMessages){
             ref.current.updateChatMessages=false;
             if(ws&&selectedChat)
             ws.send({
              action:'getMessages',
              fgtsChatId:selectedChat.id,
            });
         }
         ref.current.messages=messages;

    },[messages]);
    useEffect(()=>{

        ref.current.chats=chats;
        if(chats&&selectedChat){
          let finded=false;
          for(let chat of chats){
              if(chat.id==selectedChat.id){

                  finded=true;
                  if(chat!==selectedChat){
                    setSelectedChat(chat);
                    ref.current.upJustChat=!updateConection;
                  }

              }else{

              }
          }
          if(!finded){
             setSelectedChat(undefined);
          }
        }
        if(updateConection)
          setUpdateConection(false);
        if(loadingChats)
          setLoadingChats(false);
         ref.current.getingChats=false;
    },[chats]);
    // A reconexão automática agora é responsabilidade do ServerWebSocket (backoff
    // + watchdog), então não recriamos o socket aqui. `mustUpdate`/`updateConection`
    // ficam só como estado de UI (botão "Reconectar" / spinner).
    useEffect(()=>{
        if(loadingChats){
            if(ws&&ws.ws.readyState==WebSocket.OPEN){
               ref.current.getingChats=true;
               const f=ref.current.filters;
               ws.send({
                 action:'getChats',
                 senderNumber:f.account,
                 chatSource:f.channel,
                 state:f.state,
                 script:f.script,
                 limit:f.limit,
               });
            }

        }
    },[loadingChats]);
    return (
         <>
         <ChatFilterBar
            facets={facets}
            serverStates={serverStates}
            filters={filters}
            counts={counts}
            onChange={(partial)=>setFilters(prev=>({...prev,...partial}))}
            onRefresh={()=>{
               if(ws&&ws.ws.readyState==WebSocket.OPEN){
                  ws.send({action:'getFilters'});
                  setLoadingChats(true);
               }
            }}
         />
         <div style={{marginTop:'5px',marginBottom:'10px',display:'block',textAlign:'center'}}>
             <p>{`Conectado: Ultíma atualização ${formatDateWithMin(lastPing)}`}</p>
             <LoadingButton disabled={!mustUpdate} loading={updateConection} variant="contained" onClick={()=>{setUpdateConection(true);wsInstanceRef.current?.reconnectNow();}}>{mustUpdate?"Reconectar":"Conectado"}</LoadingButton>
         </div>
         {chats?<div>
         <div style={{
          height: `${itemsHeight}px`,
          display:'flex',
          justifyContent:'center',

        }}>
          {isMobile&&selectedChat?
             null
          :<WAConversationList loading={loadingChats} selectedChat={selectedChat} height={itemsHeight} chats={chats} isMobile={isMobile} onClick={(t)=>{
                  if(!selectedChat||selectedChat.id!==t.id) {
                    setSelectedChat(t);
                    }
                  }

               }/>}
          {!selectedChat?
          <>
          {!isMobile?<div  style={{height: `${itemsHeight}px`}} className="empty_chat_conteiner">

          </div>:null}</>:
          <div style={{width:'100%'}}>
          <WAChat senderPhone={selectedChat?.senderNumber} messages={messages} height={itemsHeight} header={selectedChat} closeChat={()=>setSelectedChat(undefined)}/>
          </div>}
          </div>
          </div>:<CircularLoading text="Carregando Conversas"/>}
          </>

    )
    function updateWS(sws?:ServerWebSocket){
        if(sws){
              if(sws.ws.readyState==WebSocket.OPEN||sws.ws.readyState==WebSocket.CONNECTING){
                   sws.close();
              }
        }
        // onOpen dispara a cada (re)conexão do wrapper — limpa o estado de UI.
        let tws=getChatWs(()=>{setMustUpdate(false);setUpdateConection(false);ref.current.triesReconection=0;});
        wsInstanceRef.current=tws;
        setWS(tws);
        return tws;
    }
    // Verifica se um chat (formato normalizado do backend) casa com os filtros ativos.
    function chatMatchesFilters(c:FGTSChatNormalizedInfo):boolean{
        const f=ref.current.filters;
        if(f.channel&&f.channel!=='all'&&c.chatSource!==f.channel)
           return false;
        if(f.account&&f.account!=='all'&&c.senderNumber!==f.account)
           return false;
        if(f.state&&f.state!=='all'&&c.currentState!==f.state)
           return false;
        if(f.script&&f.script!=='all'&&c.script!==f.script)
           return false;
        return true;
    }

    function convertChatInfo(setAllNew:boolean,data?:Array<FGTSChatNormalizedInfo>){
          if(!data)
             return;
          let newChats:Array<ChatInfo>=[];
          for(let c of data){
              const igId=c.instagramId||c.client.instagramId;
              const tgId=c.telegramId||c.client.telegramId;
              const igUsername=c.instagramUsername||c.client.instagramUsername;
              const tgUsername=c.telegramUsername||c.client.telegramUsername;
              // Identificador exibido por canal: @username + id da plataforma (Telegram/Instagram);
              // telefone/wa_id nos demais. O @ é mutável, então vem sempre atualizado do backend.
              const platformHandle=
                  c.chatSource==='telegram' ? `${tgUsername?'@'+tgUsername:''} ${tgId||''}`.trim()
                : c.chatSource==='instagram' ? `${igUsername?'@'+igUsername:''} ${igId||''}`.trim()
                : (c.client.phone||c.clientWhatsappId||'');
              // Telegram casa mensagens pelo telegram_id puro; Instagram pela chave ig_<id>.
              const recipient=c.recipient||c.clientPhone||c.clientWhatsappId||(igId?`ig_${igId}`:undefined)||tgId;
              newChats.push({
                  id:c.id,
                  name:`${c.client.name||""} ${platformHandle}`.trim()||c.id.toString(),
                  currentState:c.currentState,
                  script:c.script,
                  stopReason:c.stopReason,
                  isStoped:c.isStoped,
                  info:`${c.currentState} ${c.isStoped||''}`,
                  createdAt:c.createdAt,
                  senderNumber:c.senderNumber,
                  updatedAt:c.updatedAt,
                  clientPhone:c.clientPhone,
                  clientWhatsappId:c.clientWhatsappId,
                  recipient:recipient,
                  clientId:c.client?.id||0,
                  isPremium:c.isPremium,
                  source:c.chatSource,
                  instagramId:igId,
                  instagramUsername:igUsername,
                  telegramId:tgId,
                  telegramUsername:tgUsername,
              });
          }
          if(!setAllNew){
                let oldChats=ref.current.chats||[];
                for(let old of oldChats){
                     let has=false;
                     for(let n of newChats){
                        if(old.id==n.id){
                            has=true;
                            break;
                        }
                     }
                     if(has)
                        continue;
                     newChats.push(old);
                }
          }
          let shortedChats=newChats.slice(0,3000);
          if(setAllNew){
            shortedChats=shortDescObjectByKey(newChats,'updatedAt')
          }
          setChats(shortedChats);
    }
    function updateMessages(updatedNew:boolean,msgs?:Array<NormalizedMessages>){

         let newMessages:Array<ChatMessageModel>=[];
         if(!msgs)
           return;

         for(let m of msgs){

             newMessages.push({
                //@ts-ignore
                type:m.type,
                message:m.text||`[${m.type}]`,
                direction:m.sender==m.rootNumber?'outgoing':'incoming',
                date:m.createdAt,
                id:m.id,
                mime_type:m.mime_type,
                rootNumber:m.rootNumber,
                media_path:m.media_path,

             });
         }
         if(!updatedNew){
            newMessages=newMessages.concat(ref.current.messages);
         }
         setMessages(shortDescObjectByKey(newMessages,'date').reverse());
    }
}



function getChatWs(onOpen:Function){
   const ws=new ServerWebSocket(getWsUrl(URLS.ws.chats));
   // O wrapper já autentica (JWT) e inicia o heartbeat a cada (re)conexão;
   // aqui só refletimos o status na UI.
   ws.setOnopen(()=>{
       onOpen();
   });
   return ws;
}
